// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kge4+","loginBlock":"Header_loginBlock__PiNVC"};